import {deleteDoc} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebaseUser';
import {getTradeTagDocRef} from './getTradeTagDocRef';

export async function deleteTradeTag(id: string): Promise<void> {
  const uid = await getCurrentUserIdValidated();
  const docRef = getTradeTagDocRef(uid, id);
  await deleteDoc(docRef);
}
